import { fleetManagementApi } from "../api";

const DRIVER_EXPENSES_ENDPOINT = "/driver-expenses";

export const getDriverExpenses = async (params) => {
  if (params) {
    const queryParams = new URLSearchParams(params).toString();
    const response = await fleetManagementApi.get(`${DRIVER_EXPENSES_ENDPOINT}?${queryParams}`);
    return response;
  }
  const response = await fleetManagementApi.get(DRIVER_EXPENSES_ENDPOINT);
  return response;
};

export const getDriverExpenseById = async (driverExpenseId) => {
  const response = await fleetManagementApi.get(`${DRIVER_EXPENSES_ENDPOINT}/${driverExpenseId}`);
  return response;
};

export const createDriverExpense = async (driverExpenseData) => {
  const response = await fleetManagementApi.post(DRIVER_EXPENSES_ENDPOINT, driverExpenseData);
  return response;
};

export const updateDriverExpense = async (driverExpenseId, driverExpenseData) => {
  const response = await fleetManagementApi.put(
    `${DRIVER_EXPENSES_ENDPOINT}/${driverExpenseId}`,
    driverExpenseData
  );
  return response;
};

export const deleteDriverExpense = async (driverExpenseId) => {
  const response = await fleetManagementApi.delete(`${DRIVER_EXPENSES_ENDPOINT}/${driverExpenseId}`);
  return response;
};
